import { render, staticRenderFns } from "./fix-side-comment-edit.vue?vue&type=template&id=d7ddde80&scoped=true"
import script from "./fix-side-comment-edit.vue?vue&type=script&lang=js"
export * from "./fix-side-comment-edit.vue?vue&type=script&lang=js"
import style0 from "./fix-side-comment-edit.vue?vue&type=style&index=0&id=d7ddde80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ddde80",
  null
  
)

export default component.exports